import { render, staticRenderFns } from "./AddUsersModal.vue?vue&type=template&id=4bcf3dca&"
import script from "./AddUsersModal.vue?vue&type=script&lang=js&"
export * from "./AddUsersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports